 
'use client'
import classNames from 'classnames'
import { IconButton, type IconButtonProps } from 'design-system/client'
import { ReactNode } from 'react'
import styles from './SubmitButton.module.css'

 
export type BaseSubmitButtonProps = Omit<IconButtonProps<'button'>, 'as' | 'type'> & {
  loadingContent?: ReactNode
  busy: boolean
}

function BaseSubmitButton({
  children: children_,
  loadingContent,
  iconName,
  iconProps,
  className,
  busy,
  ...props
}: BaseSubmitButtonProps) {
  const children = busy && loadingContent ? loadingContent : children_
  return (
    <IconButton<'button'>
      {...(props as IconButtonProps<'button'>)}
      className={classNames({ [styles.loading!]: busy }, className)}
      as="button"
      type="submit"
      busy={busy}
      iconName={busy ? 'spinner' : iconName}
      iconProps={{ color: 'bg-light', size: '400', ...iconProps }}
    >
      {children}
    </IconButton>
  )
}
export default BaseSubmitButton
